import {
  createAsyncThunk,
  createReducer,
  isFulfilled,
  isPending,
  isRejected,
} from '@reduxjs/toolkit';
import { Usuario } from '../../sdk/@types';
import UsuarioService from '../../sdk/services/UsuarioService';
import AuthService from '../../app/auth/Authorization.service';
import { notification } from 'antd';
import { fetchLoggedUser } from '../../app/auth/loggedUser';

interface UsuarioState {
  list: Usuario.Usuario[];
  usuario?: Usuario.Usuario;
  fetching: boolean;
}

const initialState: UsuarioState = {
  list: [],
  usuario: {},
  fetching: false,
};

export const getUsuarios = createAsyncThunk(
  'usuario/getUsuarios',
  async () => await UsuarioService.getUsuarios()
);

export const getUsuario = createAsyncThunk(
  'usuario/getUsuario',
  async (usuario: Usuario.Usuario) => {
    
    return await UsuarioService.getUsuario(usuario.id!);
  }
);

export const getUser = createAsyncThunk(
  'usuario/getUser',
  async () => {
      const token = AuthService.getAccessToken();

      if (!token) {
        notification.error({
          message: "Usuário não autenticado",
        });
        return;
      }

      // Leitura compartilhada com o `useProfileStore`: o mesmo
      // `GET /auth/{token}` serve o menu e o perfil — ver `auth/loggedUser.ts`.
      const user: Usuario.Usuario = await fetchLoggedUser(token);

      setUser(user);    
    return user;
  }
);

export const setUser = createAsyncThunk(
  'usuario/setUser',
  async (usuario: Usuario.Usuario) => {
    return usuario;
  }
);

export default createReducer(initialState, (builder) => {
  const success = isFulfilled(getUsuarios, getUsuario);
  const error = isRejected(getUsuarios, getUsuario);
  const loading = isPending(getUsuarios, getUsuario);

  builder
    .addCase(getUsuarios.fulfilled, (state, action) => {
      state.list = action.payload;
    })
    .addCase(getUsuario.fulfilled, (state, action) => {
      state.usuario = action.payload;
    })
    .addCase(getUser.fulfilled, (state, action) => {
      state.usuario = action.payload;
    })
    .addCase(setUser.fulfilled, (state, action) => {
      state.usuario = action.payload;
    })
    .addMatcher(success, (state) => {
      state.fetching = false;
    })
    .addMatcher(error, (state) => {
      state.fetching = false;
    })
    .addMatcher(loading, (state) => {
      state.fetching = true;
    });
});
